import { check as checkFF } from '@webapp-next/lib/feature-flag';

export function checkPayrollEnabled(): boolean {
  return checkFF('payx-31-enable-payroll');
}

export function isPayrollPaywallDisabledViaFF(): boolean {
  return checkFF('payx-121-payroll-disable-paywall');
}

export function usePayrollEmployeeBulkImportTemplate(): boolean {
  return checkFF('payx-532-use-payroll-employee-bulk-import-template');
}

export function checkLeaveEntitlementSettingsEnabled(): boolean {
  return checkFF('payx-712-leave-entitlement-settings');
}

export function isClosedBetaEnabled(): boolean {
  return checkFF('payx-1039-is-payroll-closed-beta-tenant');
}

export function isBetaEnabled(): boolean {
  return checkFF('payx-1038-au-provider-microkeeper-beta');
}

export function checkPayrollAdvancedPermissionEnabled(): boolean {
  return checkFF('payx-1049-enable-payroll-advanced-permission');
}

export function checkPayrollEmailPayslips(): boolean {
  return checkFF('payx-1275-payroll-email-payslips');
}

export function checkPayrollEOI(): boolean {
  return checkFF('payx-1070-show-payroll-eoi');
}

export function checkPayrollAbnBranching(): boolean {
  return checkFF('payx-1688-enable-payroll-abn-branching');
}

export function checkUkPayrollEnabled(): boolean {
  return checkFF('payk-12-enable-uk-payroll');
}

export function checkUnifiedBusinessEntities(): boolean {
  return checkFF('chip-1973-unified-business-entities');
}
